import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateFormLibrary = ({
  Show,
  Hide,
  Title,
  getStudyFormLibraryData,
  libraryData,
  studyId
}) => {
  const [libraryName, setLibraryName] = useState("");
  const [libraryLabel, setLibraryLable] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (libraryData) {
      setLibraryName(libraryData?.name || "");
      setLibraryLable(libraryData?.label || "");
    }
  }, [libraryData]);

  const updateStudyFormLibrary = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this library?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = libraryData?._id;
        userData.studyId = studyId;
        userData.formId = libraryData?.formId;
        userData.name = libraryName;
        userData.label = libraryLabel;
        let data = await cdiscManagementService.updateStudyFormLibrary(userData);
        if (data?.statusCode === 200) {
          getStudyFormLibraryData();
          Hide();
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">
            Form Label <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Enter Form Label"
            value={libraryLabel}
            onChange={(e) => setLibraryLable(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">
            Form Name <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            placeholder="Enter Form Name"
            value={libraryName}
            onChange={(e) => setLibraryName(e.target.value)}
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button
          onClick={updateStudyFormLibrary}
          className="updateProfile"
          disabled={buttonLoader || !libraryName || !libraryLabel}
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateFormLibrary;
